import StatusPlate from './StatusPlate';

export default StatusPlate;
